module.exports = __webpack_public_path__ + "static/img/9bg_7.95569df.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_7.png
// module id = 770
// module chunks = 1